import * as React from 'react';
import { connect } from 'react-redux';
import * as $ from 'jquery';

import { CategoriesList } from './categories-list.presentation';
import { Alert } from '../common/alert/alert.presentation';
import { getCategoriesfNeeded, changePage, selectCategory } from '../../actions/categories.action';
import { Store } from '../../store/';

interface Props {
    error: string;
    page: number;
    total: number;
    items: Array<any>;
    loading: boolean;
    dispatch: any;
}

class CategoriesComponent extends React.Component<Props> {
    state = {
        view: 'cards'
    };

    constructor(props, context) {
        super(props, context);

        this.setPage = this.setPage.bind(this);
        this.selectCategory = this.selectCategory.bind(this);
        this.changeView = this.changeView.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(getCategoriesfNeeded());
    }

    setPage(page: number) {
        $('html, body').animate({scrollTop: 0}, 'slow');

        this.props.dispatch(changePage(page));
    }

    selectCategory(category: string) {
        this.props.dispatch(selectCategory(category));
    }

    changeView(e) {
        e.preventDefault();

        if (this.state.view === 'items') {
            this.setState({ view: 'cards' });
        }
        else {
            this.setState({ view: 'items' });
        }
    }

    render() {
        if (this.props.error) {
            return (<div className='container'>
                <Alert message={this.props.error} type='negative' />
            </div>);
        }
        else {
            return <CategoriesList
                    loading={this.props.loading}
                    items={this.props.items}
                    page={this.props.page}
                    total={this.props.total}
                    setPage={this.setPage}
                    limit={18}
                    selectCategory={this.selectCategory}
                    view={this.state.view}
                    changeView={this.changeView}
                />;
        }
    }
}

const mapStateToProps = (state: Store) => {
    const start = state.categories.page * 18 - 18;
    const end = start + 18;

    return {
        error: state.categories.error,
        page: state.categories.page,
        total: state.categories.total,
        items: state.categories.items.slice(start, end),
        loading: state.categories.isFetching || !state.categories.loaded
    }
};

const Categories = connect(mapStateToProps)(CategoriesComponent);

export default Categories;



// WEBPACK FOOTER //
// ./src/components/categories/categories.component.tsx